import createIcon from '../../createIcon';

/**
 * @component @name Mic
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMTQuNUMxMy42NiAxNC41IDE0Ljk5IDEzLjE2IDE0Ljk5IDExLjVMMTUgNS41QzE1IDMuODQgMTMuNjYgMi41IDEyIDIuNUMxMC4zNCAyLjUgOSAzLjg0IDkgNS41VjExLjVDOSAxMy4xNiAxMC4zNCAxNC41IDEyIDE0LjVaTTE3LjMgMTEuNUMxNy4zIDE0LjUgMTQuNzYgMTYuNiAxMiAxNi42QzkuMjQgMTYuNiA2LjcgMTQuNSA2LjcgMTEuNUg1QzUgMTQuOTEgNy43MiAxNy43MyAxMSAxOC4yMlYyMS41SDEzVjE4LjIyQzE2LjI4IDE3Ljc0IDE5IDE0LjkyIDE5IDExLjVIMTcuM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Mic = createIcon('Mic', [
  [
    'path',
    {
      d: 'M12 14.5C13.66 14.5 14.99 13.16 14.99 11.5L15 5.5C15 3.84 13.66 2.5 12 2.5C10.34 2.5 9 3.84 9 5.5V11.5C9 13.16 10.34 14.5 12 14.5ZM17.3 11.5C17.3 14.5 14.76 16.6 12 16.6C9.24 16.6 6.7 14.5 6.7 11.5H5C5 14.91 7.72 17.73 11 18.22V21.5H13V18.22C16.28 17.74 19 14.92 19 11.5H17.3Z',
      key: 'gtpfdv',
    },
  ],
]);

export default Mic;
